import React from "react";

const AccessDeniedView = () => (
  <div className="fable:text-center">
    <h1 className="cb-c-access-denied-view__error-message"> Access denied </h1>
    <p>You do not have permission to view this page.</p>
  </div>
);

export default AccessDeniedView;
